export const SPOTLIGHT_CLASS = "release-spotlight"
const SPOTLIGHT_MS = 2400

// Scrolls an element into view and outlines it briefly so a merchant can see
// where a feature announced in a banner lives on the page.
export function spotlight(el: Element | null | undefined) {
  if (!(el instanceof HTMLElement)) return
  el.scrollIntoView?.({ behavior: "smooth", block: "center" })
  el.classList.remove(SPOTLIGHT_CLASS)
  void el.offsetWidth
  el.classList.add(SPOTLIGHT_CLASS)
  const clear = () => el.classList.remove(SPOTLIGHT_CLASS)
  el.addEventListener("animationend", clear, { once: true })
  window.setTimeout(clear, SPOTLIGHT_MS + 200)
}
